<template>
	<div class="am-control">
		<am-button-icon
			class="am-control__prev"
			name="arrow-left"
			@click="$emit('prev', $event)"
		/>
		<am-button-icon
			class="am-control__next"
			name="arrow-right"
			@click="$emit('next', $event)"
		/>
	</div>
</template>

<script>
import AMButtonIcon from '@/components/molecules/AMButtonIcon'

export default {
	components: {
		'am-button-icon': AMButtonIcon
	}
}
</script>

<style lang="scss">
.am-control{
	display: inline-flex;
	position: relative;
	&:before{
		content: "";
		width: 1px;
		height: 50%;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(0, -50%);
		background: $c-brown;
		transition: .15s $easeInOutQuad;
	}
	&:hover{
		&:before{
			background: white;
		}
		.am-control{
			&__prev,
			&__next{
				background: $c-light-brown;
				border-color: $c-light-brown;
				.am-icon{
					color: white;
				}
			}
		}
	}
	&__prev,
	&__next{
		.am-icon{
			animation-duration: .5s;
			animation-iteration-count: infinite;
		}
	}
	&__prev{
		border-radius: 999px 0 0 999px;
		border-right: 0;
		padding-left: 24px;
		padding-right: 32px;
		width: auto;
		&:hover{
			.am-icon{
				animation-name: prev;
			}
		}
	}
	&__next{
		border-radius: 0 999px 999px 0;
		border-left: 0;
		padding-right: 24px;
		padding-left: 32px;
		width: auto;
		&:hover{
			.am-icon{
				animation-name: next;
			}
		}
	}

	@keyframes prev {
		0% {
			transform: translateX(0px);
		}
		50% {
			transform: translateX(-5px);
		}
		100% {
			transform: translateX(0px);
		}
	}


	@keyframes next {
		0% {
			transform: translateX(0px);
		}
		50% {
			transform: translateX(5px);
		}
		100% {
			transform: translateX(0px);
		}
	}
}
</style>
